import { BitrixVue } from 'ui.vue3';
import { createPinia } from 'ui.vue3.pinia';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import CloudCalculator from './components/CloudCalculator.vue';

BX(() => {

  const element = document.querySelector('#stsl-cloud-calculator');
  if (!element) {
    return;
  }

  const priceDate = element.dataset.priceDate;
  const priceDetailsUrl = element.dataset.priceDetailsUrl;
  const subscriptionUrl = element.dataset.subscriptionUrl;
  const arendaOfferUrl = element.dataset.arendaOfferUrl;
  const googleRecaptchaSiteKey = element.dataset.googleRecaptchaSiteKey;

  const store = createPinia();

  const calculator = BitrixVue.createApp({
    components: {
      CloudCalculator,
    },

    template: `
      <CloudCalculator
        price-date="${priceDate}"
        price-details-url="${priceDetailsUrl}"
        subscription-url="${subscriptionUrl}"
        arenda-offer-url="${arendaOfferUrl}"
      />
    `,
  });
  calculator.use(store);
  calculator.use(VueReCaptcha, { siteKey: googleRecaptchaSiteKey });
  calculator.mount(element);

});
